import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMediaQuery } from "react-responsive";
import ForSale from "./data/ForSale";
import Auction from "./data/Auction";
import LiveAuction from "./data/LiveAuction";
import SinghNft from "./data/SinghNft";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { fetchListNftStatic } from "Store/slices/nftSlice";
import { listNftStatic } from "services/apiService";

function Explore() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const [element, setElement] = useState("");

  useEffect(() => {
    fetchListNftStaticData();
  }, []);

  useEffect(() => {
    if (element) {
      // console.log("here1", searchParams.get("status"));
      // console.log("here", element.id);
      element.scrollIntoView({
        behavior: "instant",
        block: "center",
      });
    }
  }, [element]);

  const fetchListNftStaticData = async () => {
    dispatch(fetchListNftStatic(0));
    setElement(document.getElementById(searchParams.get("status")));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <MDBox sx={{ textAlign: "center", marginBottom: "1rem" }}>
          <MDTypography
            sx={{
              fontSize: isTabletOrMobile ? "15px" : "25px",
              fontWeight: "700",
            }}
          >
            Join the <span style={{ color: "#F5D243" }}>NFT </span>
            Craze{" "}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: isTabletOrMobile ? "15px" : "25px",
              fontWeight: "700",
            }}
          >
            Find Your Treasure at Our{" "}
            <span style={{ color: "#F5D243" }}>Marketplace</span> Today!
          </MDTypography>
        </MDBox>
        <Grid container spacing={4}>
          <Grid item id="For sale" xs={12}>
            {/* <Card sx={{ backgroundColor: "#08080C" }}> */}
            <MDBox>
              <ForSale />
            </MDBox>
            {/* </Card> */}
          </Grid>
          <Grid item xs={12} id="Open for bidding">
            <MDBox>
              <Auction />
            </MDBox>
          </Grid>
          <Grid item xs={12} id="Time Auction">
            <MDBox>
              <LiveAuction />
            </MDBox>
          </Grid>
          <Grid item xs={12} id="Not for sale">
            <MDBox>
              <SinghNft />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
// ReactDOM.render(<DemoCarousel />, document.querySelector('.demo-carousel'));
export default Explore;
